import { render, staticRenderFns } from "./injuryItem.vue?vue&type=template&id=a4ea87a6&scoped=true&"
import script from "./injuryItem.vue?vue&type=script&lang=tsx&"
export * from "./injuryItem.vue?vue&type=script&lang=tsx&"
import style0 from "./injuryItem.vue?vue&type=style&index=0&id=a4ea87a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4ea87a6",
  null
  
)

export default component.exports